<template>
  <section :id="$style.attention">
    <sub-title :title="'注意事項'"></sub-title>
    <ol>
      <li :class="$style.first_list">
        当館では下記の事項が禁止されています。
        <ul>
          <li>
            <b>禁煙</b>
          </li>
          <li>
            <b>展示室での飲食</b>
          </li>
          <li>
            <b>展示室でのフラッシュ撮影</b>
            (一部撮影禁止のものもございます。)
          </li>
          <li>
            <b>ビデオ（動画）撮影</b>
          </li>
          <li>
            <b>ペットの持ち込み</b>
            (盲導犬・ゲージに入ったペットは可)
          </li>
          <li>
            野球用等の
            <b>スパイクシューズでの入館</b>
          </li>
        </ul>
      </li>
      <li :class="$style.first_list">他のお客様の迷惑となるような行為があった場合は、退場していただくことがあります。</li>
      <li :class="$style.first_list">展示室にはお手洗いがありません。エントランスのお手洗いをご利用ください。</li>
      <li :class="$style.first_list">団体でお越しの場合も、予約不要です。</li>
      <li :class="$style.first_list">
        入場料の
        <b>払い戻しはお受けできません</b>。必要枚数のみご購入ください。
      </li>
    </ol>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import SubTitle from "@/components/atoms/SubTitle.vue";
export default Vue.extend({
  name: "AttentionVisual",
  components: {
    SubTitle
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #attention {
    ol {
      .first_list {
        margin-bottom: 20px;
      }
    }
    ol,
    ul,
    dl {
      padding-left: 25px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #attention {
    ol {
      .first_list {
        margin-bottom: 20px;
      }
    }
  }
}
</style>

